import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../Utils/Common";
import { ResponseMessage } from "../../components/messages/response-message";

export default function ContactPage() {
  // const token = getToken();

  const [error, setError] = useState([]);
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");

  // const [loader, setLoader] = useState(true);
  const token = getToken();

  const [state, setState] = React.useState({
    from_name: "",
    from_email: "",
    subject: "",
    message: "",
  });

  // useEffect(() => {
  //     setLoader(false);
  // }, [])

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);

    var formData = new FormData();
    formData.append("from_email", state.from_email);
    formData.append("subject", state.subject);
    formData.append("text", state.message);

    for (var key of formData.entries()) {
      formData[key[0]] = key[1];
      // console.log(formData);
    }

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/guest/help-email`,
      headers: {
        Accept: "application/json",
        // Authorization: `Bearer ${token}`,
      },
      data: formData,
    })
      .then((response) => {
        // console.log(response.data.message);
        if (response.status === 200) {
          console.log(response);
          setStatus(200);
          setMessage(response.data.message);
          // setLoader(true)
          navigate("/contact/email-send");
        }
      })
      .catch((error) => {
        if (error.response.status === 422) {
          console.log(error.response);
          // setError(error.response.data.message);
          setStatus(422);
          setMessage(error.response.data.message);
        } else if (error.response.status === 500) {
          console.log(error.response);
          setStatus(500);
          setMessage("Something went wrong. Please try again later.");
          // setError("Something went wrong. Please try again later.");
        } else {
          console.log(error.response);
          setMessage("Something went wrong. Please try again later.");
          setError("Something went wrong. Please try again later.");
        }
        // console.log(error.response);
      })
      .then(function () {
        // always executed
        // setLoader(false);
      });
  };

  return (
    <div className="card mb-5 mb-xl-8 mt-19">
      <div className="container h-1000px">
        <div className="bg-body text-start rounded shadow-sm p-10 p-lg-15 ms-19 mt-19">
          {/* <div className="d-flex justify-content-center">
                        <div
                            className={loader === true ? "spinner-border" : ""}
                            role="status"
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div> */}
          <form method="POST" onSubmit={handleSubmit}>
            <h1>Email Us</h1>
            <div className="d-flex flex-stack mb-2 mt-10">
              <label className="form-label fw-bolder text-dark fs-6 mb-0">
                To:
              </label>
              {/*end::Link*/}
            </div>
            {/*end::Wrapper*/}
            {/*begin::Input*/}
            {/* <input
                            className="form-control form-control-lg form-control-solid"
                            type="text"
                            name="from_name"
                            id="from_name"
                            placeholder="Customer Service"
                            onChange={handleChange}
                            disabled
                        /> */}
            <div placeholder="Customer Service" className="text-gray-500 fs-3">
              {" "}
              Customer Service{" "}
            </div>

            <div className="d-flex flex-stack mb-2 mt-10">
              <label className="form-label fw-bolder text-dark fs-6 mb-0">
                Email:
              </label>
              {/*end::Link*/}
            </div>
            {/*end::Wrapper*/}
            {/*begin::Input*/}
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="from_email"
              id="from_email"
              placeholder="Customer@service.com"
              onChange={handleChange}
              required
            />

            <div className="d-flex flex-stack mb-2 mt-10">
              <label className="form-label fw-bolder text-dark fs-6 mb-0">
                Subject:
              </label>
              {/*end::Link*/}
            </div>
            {/*end::Wrapper*/}
            {/*begin::Input*/}
            <input
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="subject"
              id="subject"
              onChange={handleChange}
              required
            />

            <div className="d-flex flex-stack mb-2 mt-10">
              <label className="form-label fs-6 fw-bolder text-dark">
                Describe your issue or idea below.
              </label>
            </div>

            <textarea
              className="form-control form-control-lg form-control-solid"
              type="text"
              name="message"
              id="message"
              onChange={handleChange}
              required
              rows="10"
              cols="50"
              autoComplete="true"
            />

            <div className="text-start mt-10">
              {/*begin::Submit button*/}
              <button type="submit" className="btn btn-lg btn-dark w-150px">
                <span className="indicator-label"> Send e-mail </span>
              </button>
              {/*end::Separator*/}
            </div>

            <div className="text-center mt-10">
              {/*begin::Submit button*/}
              <p> conditions of use: </p>
              {/*end::Separator*/}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
